import { PropsWithChildren } from 'react';
import useApiFetch from '@/hooks/useApiFetch';
import staffMemberServices from '@/services/staffMember';
import { FetchApiIds } from '@/types';
import Context from './StaffMemberByPerson.context';

export type Props = PropsWithChildren<{
  personId: string;
}>;

const StaffMemberByPerson = ({ personId, children }: Props): JSX.Element => {
  const { data: staffMember, isLoading } = useApiFetch(
    [FetchApiIds.GET_STAFF_MEMBER_BY_PERSON, personId],
    async () => staffMemberServices.getStaffMemberByPersonId({ personId })
  );

  return <Context.Provider value={{ staffMember, isLoading }}>{children}</Context.Provider>;
};

export default StaffMemberByPerson;
